import React, { PureComponent } from 'react';


import PropTypes from 'prop-types';
import styled from 'styled-components';

import convertPlainTextToHTML from '../../../../lib/convertPlainTextToHTML';
import FieldInput from '../FieldInput';
import TableDataCell from './TableDataCell';
import DateTimePicker from '../../../misc/DateTimePicker';

const StyledDisplayText = styled.div`
  ${(props) => (props.textOverflow ? `text-overflow: ${props.textOverflow};` : '')}
  ${(props) => (props.textOverflow === 'ellipsis' ? 'white-space: nowrap;' : '')}
  ${(props) => (props.textOverflow === 'ellipsis' ? 'overflow: hidden;' : '')}
  overflow-wrap: break-word;
`;

class TableFieldDateCell extends PureComponent {

  static propTypes = {
    id: PropTypes.string,
    disabled: PropTypes.bool,
    focused: PropTypes.bool,
    rowId: PropTypes.string,
    columnId: PropTypes.string,
    cellKey: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyPress: PropTypes.func,

    //Styles
    fontSize: PropTypes.number,
    fontColor: PropTypes.string,
    fontStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    textAlign: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    textOverflow: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.number,
    backgroundColor: PropTypes.string,
    padding: PropTypes.number,
    width: PropTypes.number,

  }

  constructor(props) {
    super(props);
    this.state = { changes: props.value };
  }

  componentWillUnmount() {

    const { onChange, focused, value, rowId, columnId, columnIdentifier, onBlur, timezone } = this.props;
    const { changes } = this.state;

    /**
     * DO NOT REMOVE
     *
     * When a component is unmounted the blur event doesn't get fired.
     * This ensure that inputs that rely on the blur event have their
     * changes saved even when react is unmounting them.
     *
     * See: https://github.com/zionlabs/Issues/issues/1205
     *
     */
    if (onChange && focused && changes !== value && onBlur) {

      const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const args = [rowId, columnId, changes];

      //Only update the timezone if it's not alredy set on a field
      if (!timezone || timezone === undefined) {
        args.push(localTimezone);
      }

      onChange(...args);

      onBlur(rowId, columnId, columnIdentifier, {});

    }

  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;

    if (prevProps.value !== value) {
      this.setState({ changes: value });
    }

  }

  render() {

    const {
      id,
      rowId,
      columnId,
      disabled,
      cellKey,
      focused,
      primaryColor,

      //Field style
      fontSize,
      fontColor,
      fontStyle,
      fontWeight,
      textAlign,
      textTransform,
      textDecoration,
      textOverflow,
      borderColor,
      borderWidth,
      backgroundColor,
      padding,
      width,
      format,
      timezone,
      tz
    } = this.props;


    const { changes } = this.state;

    const fieldStyles = {
      disabled,
      focused,
      fontSize,
      fontColor,
      fontStyle,
      fontWeight,
      textAlign,
      textTransform,
      textDecoration,
      textOverflow,
      borderColor,
      borderWidth,
      backgroundColor,
      padding,
      primaryColor,
    }

    return (
      <TableDataCell
        key={`${cellKey}-editable`}
        data-testid={`${id}-${rowId}-${columnId}-number-cell`}
        disabled={disabled}
        {...{
          focused,
          width,
          padding: 0,
          borderColor,
          borderWidth,
          backgroundColor,
          primaryColor
        }}
      >
        <DateTimePicker
          disabled={disabled}
          value={changes}
          format={format}
          timezone={timezone}
          enableTimezoneAnchor={true}
          customStyles={fieldStyles}
          onChange={this.handleChange}
          onClick={this.handleFocus}
          onClose={this.handleClose}
        />
      </TableDataCell>
    )
  }

  handleFocus = (e) => {

    const { onFocus, rowId, columnId, columnIdentifier, columnType, } = this.props;

    if (onFocus) {
      onFocus(rowId, columnId, columnIdentifier, columnType, { blur: e.blur });
    }

  }

  handleChange = (timestamp, timezone) => {

    const { value, onChange, rowId, columnId } = this.props;

    /**
     * Timezone Note: DateTimePicker will return the existing timezone if it exists
     * or a new timezone if one doesn't exist as the second argument
     * 
     * Timestamp Note: DateTimePicker will return the new timestamp as the first argument
     * and handles the timezone anchoring internally.
     */
    if (onChange && timestamp !== value) onChange(rowId, columnId, timestamp, timezone);

  }

  handleClose = () => {
    const { onBlur, rowId, columnId, columnIdentifier } = this.props;
    if (onBlur) onBlur(rowId, columnId, columnIdentifier, {});
  }

}

export default TableFieldDateCell;
